/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpcomingOccurrenceResponse
 */
export interface UpcomingOccurrenceResponse {
    /**
     * 
     */
    scheduleId?: string;
    /**
     * 
     */
    templateId?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    frequency?: string;
    /**
     * 
     */
    occurrenceAt?: string;
    /**
     * 
     */
    status?: string;
}

/**
 * Check if a given object implements the UpcomingOccurrenceResponse interface.
 */
export function instanceOfUpcomingOccurrenceResponse(value: object): value is UpcomingOccurrenceResponse {
    return true;
}

export function UpcomingOccurrenceResponseFromJSON(json: any): UpcomingOccurrenceResponse {
    return UpcomingOccurrenceResponseFromJSONTyped(json, false);
}

export function UpcomingOccurrenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpcomingOccurrenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'scheduleId': json['scheduleId'] == null ? undefined : json['scheduleId'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'occurrenceAt': json['occurrenceAt'] == null ? undefined : json['occurrenceAt'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function UpcomingOccurrenceResponseToJSON(json: any): UpcomingOccurrenceResponse {
    return UpcomingOccurrenceResponseToJSONTyped(json, false);
}

export function UpcomingOccurrenceResponseToJSONTyped(value?: UpcomingOccurrenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scheduleId': value['scheduleId'],
        'templateId': value['templateId'],
        'machineId': value['machineId'],
        'frequency': value['frequency'],
        'occurrenceAt': value['occurrenceAt'],
        'status': value['status'],
    };
}

